import { render } from "./company-profile.vue?vue&type=template&id=79208ef0"
import script from "./company-profile.vue?vue&type=script&lang=js"
export * from "./company-profile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__